import React, { useState } from 'react';

export default function Carousel({ images }) {
  const [current, setCurrent] = useState(0);

  if (!images || images.length === 0) {
    return <img src="https://placehold.co/500x300/png" alt="placeholder" style={{ width: '100%', borderRadius: 8 }} />;
  }

  if (images.length === 1) {
    return (
      <img
        src={images[0].imageUrl || 'https://placehold.co/500x300/png'}
        alt="product"
        style={{ width: '100%', borderRadius: 8, objectFit: 'cover' }}
        onError={e => { e.target.src = 'https://placehold.co/500x300/png'; }}
      />
    );
  }

  const prev = () => setCurrent((current - 1 + images.length) % images.length);
  const next = () => setCurrent((current + 1) % images.length);

  return (
    <div className="carousel">
      <img
        src={images[current].imageUrl || 'https://placehold.co/500x300/png'}
        alt={`slide ${current + 1}`}
        style={{ width: '100%', height: 280, objectFit: 'cover' }}
        onError={e => { e.target.src = 'https://placehold.co/500x300/png'; }}
      />
      <button className="carousel-btn prev" onClick={prev}>‹</button>
      <button className="carousel-btn next" onClick={next}>›</button>
      <div style={{ textAlign: 'center', padding: '0.5rem 0', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
        {current + 1} / {images.length}
      </div>
    </div>
  );
}
